export const REVIEW_MEDIA_TYPE = {
  IMAGE: 1,
  VIDEO: 2,
};

export const REVIEW_RATING_STATUS = {
  NEW: 2,
  PUBLISHED: 1,
  UNPUBLISHED: 0,
};
